<app-header-component />
<div class="main">
  <router-outlet />
</div>
<app-footer-component />
